import * as React from 'react';

import Input from 'antd/es/input';

import * as Yup from 'yup';

import { useModal } from '@common/react/components/Modal/ModalContextProvider';
import { emailValidator, simpleStringValidator } from '@common/react/utils/validationHelpers';
import Button from '@common/react/components/Forms/Button';
import FormikField from '@common/react/components/Forms/FormikField/FormikField';
import { useApplicationContext } from '@common/react/components/Core/Application/Application';
import { ItemProvider } from '@common/react/components/Core/ItemProvider/ItemProvider';
import { ItemEditor } from '@common/react/components/Core/ItemEditor/ItemEditor';

import { User } from '@app/objects/User';

interface IFormValues {
	id: number;
	fullName: string;
	email: string;
	subject: string;
	message: string;
}

const validationSchema = Yup.object().shape({
	fullName: simpleStringValidator,
	email: emailValidator,
	message: simpleStringValidator,
});

const ContactSupport: React.FC = () => {
	const { openSuccessMessage } = useModal();
	const { getUser } = useApplicationContext();
	const user = getUser<User>();

	const init = {
		id: -1,
		fullName: user ? `${user.firstName}${user.lastName ? ` ${user.lastName}` : ''}` : '',
		email: user?.email || '',
		subject: '',
		message: '',
	};

	return <ItemProvider<IFormValues>
		id={-1}
		add={init}
		skipInitLoad
		item={init}
		saveRequest="sendSupportEmail"
		validationSchema={validationSchema}
		transformAfterSave={() => init}
	>
		<ItemEditor<IFormValues>
			afterSubmit={() => {
				openSuccessMessage?.('Your email has been successfully sent.');
			}}
			edit={({ formikBag, state: { loading } }) => <>
				<div className="row">
					<FormikField
						title="Full Name*"
						fieldName="fullName"
						containerClassName="form-group col-sm-12"
					/>
				</div>
				<div className="row">
					<FormikField
						title="Email*"
						fieldName="email"
						containerClassName="form-group col-sm-12"
					/>
				</div>
				<div className="row">
					<FormikField
						title="Subject"
						fieldName="subject"
						containerClassName="form-group col-sm-12"
					/>
				</div>
				<div className="row">
					<FormikField
						title="Message*"
						fieldName="message"
						containerClassName="form-group col-sm-12"
						render={({ field }) =>
							<Input.TextArea
								className="form-control input-textarea"
								style={{ minHeight: '68px', resize: 'none' }}
								autoSize={{ minRows: 3, maxRows: 10 }}
								{...field}
							/>
						}
					/>
				</div>
				<div className="mb10 text-center">
					<Button
						type="button"
						className="btn btn-sm btn-primary"
						isLoading={loading}
						onClick={() => formikBag.handleSubmit()}
					>
						Send Message
					</Button>
				</div>
			</>}
		/>
	</ItemProvider>;
};

export default ContactSupport;
